<div class="preview-wrapper"
  [class.has-preview]="selectedTemplate && !loading"
  [class.no-preview]="loading || !selectedTemplate"
  tabindex="0">
  <div *ngIf="loading">
    <ng-template *ngTemplateOutlet="previewMessage;
      context: {
        icon: 'spinner',
        message: 'CONFIG:textLoadingDocumentPreview' | ycI18n: 'Loading document preview'
      }">
    </ng-template>
  </div>
  <div *ngIf="!selectedTemplate && !loading">
    <ng-template *ngTemplateOutlet="previewMessage;
      context: {
        icon: 'file-image',
        message: 'CONFIG:textYourDocumentPreviewWillAppearHere' | ycI18n: 'Your document preview will appear here'
      }">
    </ng-template>
  </div>
  <iframe [ycHidden]="previewError || !selectedTemplate"
    #previewContainer
    class="preview">
  </iframe>
  <div *ngIf="previewError">
    <ng-template *ngTemplateOutlet="previewMessage;
      context: {
        icon: 'exclamation-triangle',
        message: 'CONFIG:textErrorLoadingPreview' | ycI18n: 'There was an error loading the preview',
        iconClass: 'text-warning'
      }">
    </ng-template>
  </div>
</div>

<ng-template #previewMessage
  let-icon="icon"
  let-message="message"
  let-iconClass="iconClass">
  <div class="no-preview-message">
    <!--Icon -->
    <div>
      <yc-fa
        class="fa-4x"
        [icon]="icon"
        [light]="true"
        [ngClass]="iconClass || 'text-link'">
      </yc-fa>
    </div>
    <div class="message">
      {{ message }}
    </div>
  </div>
</ng-template>